<app-sidebar></app-sidebar>

<div class="statistics-container">
  <nav class="sub-tabs">
    <a class="sub-tab" routerLink="heatmap" routerLinkActive="active">
      {{ 'Heatmap' | translate }}
    </a>
    <a class="sub-tab" routerLink="riding-statistics" routerLinkActive="active">
      {{ 'Riding Statistics' | translate }}
    </a>
  </nav>

  <div class="sub-tab-content">
    <router-outlet></router-outlet>
  </div>
</div>